<template>
  <div>
    <v-autocomplete
      :value="selected"
      @input="select"
      :items="items"
      :label="label"
      :filter="filter"
      :no-data-text="lang.orders.new.order.no_results(catalog_s)"
      item-text="title"
      item-value="id"
      :return-object="returnObject"
      :clearable="clearable"
      clear-icon="mdi-broom"
      prepend-inner-icon="mdi-plus-thick"
      autocomplete="off"
      :class="{ 'order-autocomplete': true, 'hide-chips': hideChips }"
      :chips="!hideChips"
      :single-line="false"
      filled
      multiple
      hide-details
    >
      <template v-slot:selection="{ item, selected }">
        <v-chip
          v-if="!hideChips"
          :input-value="selected"
          close
          class="chip--select-multi"
          @click:close="remove(item)"
        >
          <Thumb
            v-if="item.photo"
            :photo="item.photo"
            :size="20"
            class="mr-2"
          />
          {{ item.title }}
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar>
          <Thumb
            :photo="item.photo"
            :size="40"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ `${(String(item.cod).trim().length > 0 ? '#' + String(item.cod).trim() + ' - ': '')}${item.title}` }}
            <span class="price">{{ formatCurrency(item.price) }}</span>
          </v-list-item-title>
          <v-list-item-subtitle>{{ (item.cat ? item.cat_name : lang.categories.new.no_cat) }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Thumb from '@/components/catalog/items/templates/Thumb'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Thumb },
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    catalog: {
      type: String,
      default: 'services'
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    isOrder: {
      type: Boolean,
      default: false
    },
    hideChips: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: (this.value[this.catalog] ? [ ...this.value[this.catalog] ] : [])
    }
  },
  computed: {
    items: {
      get () {
        const catalog = this.get_data.catalog || []
        let filtered = catalog.filter(cat => cat.catalog === this.catalog) || []
        let items = Object.values(filtered)
        let group = items.reduce((r, a) => {
          r[a.parent_cat] = [...r[a.parent_cat] || [], a]
          return r
        }, [])
        const flatten = group.reduce((add, val) => add.concat(val), [])
        const orderAssign = (price) => ({
          qty: 1,
          total: price,
          adt: [],
          obs: ''
        })
        let result = []
        var currentCat = null
        flatten.forEach((value) => {
          if (currentCat !== value.parent_cat) result.push({ header: (value.parent_cat === 0 ? this.lang.categories.new.no_cat : value.parent_cat_name) })
          // ADD ORDER DEFAULTS
          value = (this.isOrder ? Object.assign({ ...value }, { ...orderAssign(value.price) }) : value)
          if (typeof value.UUID === 'undefined') value.UUID = this.getRandomUnique()
          currentCat = value.parent_cat
          result.push({ ...value })
        })
        return [ ...result ]
      },
      set () {
        /* */
      }
    },
    label () {
      let catalogName = (this.lang[this.catalog] || {}).title || ''
      return `${this.lang.orders.new.order.autocomplete} ${catalogName}`
    },
    catalog_s () {
      return (this.lang[this.catalog] || {}).title_s || ''
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value[this.catalog]) !== JSON.stringify(newVal)) this.$emit('input', { list: [ ...this.selected ], catalog: this.catalog })
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal[this.catalog])) this.selected = [ ...this.value[this.catalog] ]
      }
    },
    catalog (newVal) {
      this.selected = [ ...this.value[newVal] ]
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    filter (item, queryText, itemText) {
      if (typeof item.header === 'undefined' && queryText) {
        return (
          (item.title.toLowerCase().trim().search(queryText.toLowerCase()) > -1) ||
          (item.description.toLowerCase().trim().search(queryText.toLowerCase()) > -1) ||
          (this.formatCurrency(item.price).toLowerCase().trim().search(String(queryText)) > -1) ||
          (item.cat_name !== 0 && item.cat_name.toLowerCase().trim().search(queryText.toLowerCase()) > -1) ||
          (item.parent_cat_name !== 0 && item.parent_cat_name.toLowerCase().trim().search(queryText.toLowerCase()) > -1)
        )
      }
    },
    select (items) {
      this.$set(this, 'selected', [ ...items ])
    },
    remove (item) {
      const obj = (this.returnObject ? this.selected.find(el => el.id === item.id) : this.selected.find(el => el === item.id))
      const index = this.selected.indexOf(obj)
      if (index >= 0) this.selected.splice(index, 1)
      this.$root.$emit('order-widget-list', { action: 4, value: item.UUID })
    }
  }
}
</script>

<style scoped src="../../../styles/autocomplete.scss" lang="scss"></style>
<style lang="scss">
#app .order-autocomplete {
  border-radius: 0px !important;
  margin-top: -2px;
  .v-select__selections {
    margin-top: 0px !important;
    padding-top: 13px !important;
  }
  .v-label {
    font-size: 15px !important;
    position: absolute !important;
    top: 19px !important;
    transform: none !important;
  }
  &.v-input--is-focused {
    .v-label {
      visibility: hidden;
    }
  }
  .price {
    float: right;
  }
}
</style>
